import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Create a new tracker.
 * @param trackerData {object}
 * @returns {Promise<AxiosResponse<object>>}: newly created tracker.
 * @constructor
 */
const Create = async trackerData => mainHTTPClient.post(
  MAIN_HTTP_API_ENDPOINTS.TRACKERS,
  trackerData
)

/**
 * Get data of specified tracker.
 * @param trackerId {string}
 * @returns {Promise<AxiosResponse<object>>}: tracker data.
 * @constructor
 */
const GetTrackerInfo = async trackerId => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.TRACKER.replace(':id', trackerId)
)

/**
 * Update the specified tracker's data.
 * @param trackerId {string}
 * @param trackerData {object}
 * @returns {Promise<AxiosResponse<any>>}: updated tracker data.
 * @constructor
 */
const Update = async (trackerId, trackerData) => mainHTTPClient.put(
  MAIN_HTTP_API_ENDPOINTS.TRACKER.replace(':id', trackerId),
  trackerData
)

/**
 * Delete specified tracker.
 * @param trackerId {string}
 * @returns {Promise<AxiosResponse<string>>}: OK in case the deletion was successful.
 * @constructor
 */
const Delete = async trackerId => mainHTTPClient.delete(
  MAIN_HTTP_API_ENDPOINTS.TRACKER.replace(':id', trackerId)
)

/**
 * Send output to the specified tracker.
 * @param trackerId {string}
 * @param outputId {string}
 * @returns {Promise<AxiosResponse<string>>}: OK in case the output was successful.
 * @constructor
 */
const SendOutput = async (trackerId, outputId) => mainHTTPClient.post(
  MAIN_HTTP_API_ENDPOINTS.TRACKER_OUTPUTS,
  {
    id: outputId,
    trackerId
  }
)

/**
 * Listen to the microphone of the specified tracker.
 * @param trackerId {string}
 * @param listeningPhoneNumber {string}
 * @returns {Promise<AxiosResponse<string>>}: OK in case the call was successfully made.
 * @constructor
 */
const Listen = async (trackerId, listeningPhoneNumber) => mainHTTPClient.post(
  MAIN_HTTP_API_ENDPOINTS.TRACKER_LISTEN.replace(':id', trackerId),
  {
    listeningPhoneNumber
  }
)

/**
 * Update the isActive attribute of the tracker.
 * @param trackerId {string}
 * @param isActive {boolean}
 * @returns {Promise<AxiosResponse<string>>}: OK in case the attribute was successfully updated.
 * @constructor
 */
const UpdateIsActiveAttribute = async (trackerId, isActive) => mainHTTPClient.post(
  MAIN_HTTP_API_ENDPOINTS.TRACKER_ACTIVE_ATTRIBUTE.replace(':id', trackerId),
  {
    isActive
  }
)

/**
 * Delete the association between a tracker and its user.
 * @param trackerId {string}
 * @returns {Promise<AxiosResponse<string>>}: OK in case the association was successfully deleted.
 * @constructor
 */
const DetachUser = async trackerId => mainHTTPClient.delete(
  MAIN_HTTP_API_ENDPOINTS.TRACKER_USER.replace(':id', trackerId)
)

/**
 * Sends command to tracker.
 * @param trackerId {string}
 * @param command {string}
 * @returns {Promise<AxiosResponse<string>>}: OK in case the command was successfully sent.
 * @constructor
 */
const SendCommand = async (trackerId, command) => mainHTTPClient.post(
  MAIN_HTTP_API_ENDPOINTS.TRACKER_COMMAND.replace(':id', trackerId),
  {
    command
  }
)

/**
 * Search for trackers.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.TRACKERS,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const TrackerService = {
  Create,
  GetTrackerInfo,
  Update,
  Delete,
  SendOutput,
  Listen,
  UpdateIsActiveAttribute,
  DetachUser,
  SendCommand,
  FindMany
}

export default TrackerService

